module.exports = __webpack_public_path__ + "static/media/vescom.41a65fec.jpg";